var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.value)?_c('span',{staticClass:"text-muted"},[_vm._v(" — ")]):_c('span',[_vm._v(" "+_vm._s(_vm.t('generic.number', {value: _vm.value, prefix: _vm.prefix, suffix: _vm.suffix}))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }